import { Component, DoCheck, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;

export interface ICarouselHomeImages {
    url: string;
    id?: string;
}
export interface ICarouselHomeText {
    title: string;
    body?: string;
}

@Component({
  selector: 'app-carousel-home',
  templateUrl: './carousel-home.component.html',
  styleUrls: ['./carousel-home.component.scss']
})
export class CarouselHomeComponent implements OnInit, DoCheck {

    @Input() lists: ICarouselHomeImages[];
    @Input() bannertext: string;
    @Input() bannerDesc: string;
    bannertObj = {} as ICarouselHomeText;
    constructor(
        private router: Router
    ) { }

    public searchString: any;

    ngOnInit(): void {
        const minterval = setInterval(() => {
            if (this.lists != null && this.lists.length > 0){
                clearInterval(minterval);
                this.carouselInit();
            }
        }, 250);

        const minterval2 = setInterval(() => {
            if (this.bannertext != null && this.bannertext){
                clearInterval(minterval2);
                // this.bannerTextSplit();
            }
        }, 250);
    }

    bannerTextSplit(): void{
        this.bannertObj.title = this.bannertext.substring(this.bannertext.indexOf('<h3>') + 4, this.bannertext.indexOf('</h3>'));
        this.bannertObj.body = this.bannertext.substring(this.bannertext.indexOf('<p>') + 3, this.bannertext.indexOf('</p>'));
    }

    carouselInit(): void {

        $('[data-toggle="offcanvas"]').on('click', function () {
        $('.offcanvas-collapse').toggleClass('open');
        });

        $('.carousel-home').not('.slick-initialized').slick({
            autoplay: true,
            prevArrow: '<span class=\'slick-prev ic-\'>arrow_circle_right</span>',
            nextArrow: '<span class=\'slick-next ic-\'>arrow_circle_right</span>'
        });

        // $('.most-popular').not('.slick-initialized').slick({
        //     infinite: true,
        //     speed: 300,
        //     slidesToShow: 4,
        //     slidesToScroll: 1,
        //     responsive: [
        //         {
        //             breakpoint: 1024,
        //             settings: {
        //                 slidesToShow: 4,
        //                 slidesToScroll: 2,
        //                 infinite: true,
        //                 dots: false
        //             }
        //         },
        //         {
        //             breakpoint: 1023,
        //             settings: {
        //                 slidesToShow: 2,
        //                 slidesToScroll: 2
        //             }
        //         },
        //         {
        //             breakpoint: 480,
        //             settings: {
        //                 slidesToShow: 1,
        //                 slidesToScroll: 1
        //             }
        //         }
        //     ]
        // });

        // $('.reviews').not('.slick-initialized').slick({
        //     infinite: false,
        //     speed: 300,
        //     slidesToShow: 3,
        //     slidesToScroll: 1,
        //     arrows: false,
        //     dots: true,
        //     responsive: [
        //         {
        //             breakpoint: 1023,
        //             settings: {
        //                 slidesToShow: 2,
        //                 slidesToScroll: 2
        //             }
        //         },
        //         {
        //             breakpoint: 480,
        //             settings: {
        //                 slidesToShow: 1,
        //                 slidesToScroll: 1
        //             }
        //         }
        //     ]
        // });

        // $('.carousel-inner').not('.slick-initialized').slick({
        //     arrows: true
        // });

        // $('.astro-listing').not('.slick-initialized').slick({
        //     infinite: true,
        //     speed: 4000,
        //     autoplay: true,
        //     slidesToShow: 4,
        //     slidesToScroll: 1,
        //     responsive: [
        //         {
        //             breakpoint: 1024,
        //             settings: {
        //                 slidesToShow: 3,
        //                 slidesToScroll: 2,
        //                 infinite: true,
        //                 dots: false
        //             }
        //         },
        //         {
        //             breakpoint: 1023,
        //             settings: {
        //                 slidesToShow: 2,
        //                 slidesToScroll: 2
        //             }
        //         },
        //         {
        //             breakpoint: 480,
        //             settings: {
        //                 slidesToShow: 1,
        //                 slidesToScroll: 1
        //             }
        //         }
        //     ]
        // });

        // tslint:disable-next-line:typedef
        $(function() {
            $('#myList a:last-child').tab('show');
        });
    }

    changeSearchValue(event: any): void{
        console.log(event);
    }

    ngDoCheck(): void {
    //    if (this.lists != null && this.lists.length > 0){
    //         this.carouselInit();
    //     }
    }

    gotoExplore(): void{
        this.router.navigate(['pooja']);
    }
}
